import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH, faWifi } from '@fortawesome/free-solid-svg-icons';

import CommandHistoryTable from './CommandHistoryTable';
import JobMobileCard from './JobMobileCard';
import MobileFiltersModal from '../MobileFiltersModal';
import { Loading } from '../NoDataIndication';
import PaginationFooter from '../PaginationFooter';
import { STICKY_OVERRIDE } from '../../Styles/Z-INDEX';

export default function AssetCommandHistoryDisplay(props) {
  const {
    data,
    dataLoading,
    page,
    pages,
    handlePageChange,
    showMobileFilters,
    toggleMobileFilters,
    jobName,
    handleSearch,
    remote,
    error,
  } = props;
  return (
    <>
      <button
        className="d-lg-none btn btn-link p-0 position-absolute shadow-none text-decoration-none"
        onClick={() => toggleMobileFilters(!showMobileFilters)}
        style={{ right: '0.5rem', top: '-5.7rem', zIndex: STICKY_OVERRIDE }}
      >
        <FontAwesomeIcon
          className="text-brand-primary"
          icon={faSlidersH}
          size="lg"
        />
      </button>
      <div className="position-absolute overflow-auto container-fluid h-100 bg-white rounded-lg mt-3 mt-lg-0 d-flex flex-column">
        <div className="d-none d-md-flex row flex-grow-1 overflow-auto command-history-table-container">
          <CommandHistoryTable {...props} />
        </div>
        <div className="d-md-none row no-gutters flex-grow-1">
          <div className="col-12 d-flex align-items-center py-3 sticky-top bg-white">
            <span className="font-weight-bolder mr-3">
              Command and Control Log
            </span>
            <FontAwesomeIcon icon={faWifi} className="text-brand-primary" />
          </div>
          {(() => {
            switch (true) {
              case dataLoading:
                return (
                  <div className="h-75 w-100 d-flex align-items-center justify-content-center">
                    <Loading />
                  </div>
                );
              case !remote:
                return (
                  <div className="h-75 w-100 d-flex flex-column align-items-center justify-content-center">
                    <FontAwesomeIcon
                      icon={faWifi}
                      className="text-brand-primary mb-3"
                      size="5x"
                    />
                    <h4 className="text-brand-primary">
                      This asset is not remote enabled
                    </h4>
                  </div>
                );
              case !data.length:
                return (
                  <div className="h-75 w-100 d-flex flex-column align-items-center justify-content-center">
                    <FontAwesomeIcon
                      icon={faWifi}
                      className="text-brand-primary mb-3"
                      size="5x"
                    />
                    <h5 className="text-brand-primary">
                      No commands have been fired on this asset!
                    </h5>
                  </div>
                );
              default:
                return data.map((job) => (
                  <JobMobileCard key={job._id} job={job} />
                ));
            }
          })()}
        </div>
        <div className="row justify-content-end">
          <p className="col-12 text-danger three-quarter-text text-right">
            {error}
          </p>
        </div>
        <div className="py-1 py-lg-2">
          <PaginationFooter
            handlePageChange={handlePageChange}
            page={page}
            pages={pages}
            rowsLength={data?.length}
            rowsLoading={dataLoading}
          />
        </div>
        <MobileFiltersModal
          isOpen={showMobileFilters}
          toggleModal={toggleMobileFilters}
          searchTerm={jobName}
          handleSearch={handleSearch}
          resource="job"
        />
        <style jsx>{`
          @media (min-width: 992px) {
            .command-history-table-container {
              max-height: calc(100% - 3rem);
            }
          }
        `}</style>
      </div>
    </>
  );
}

AssetCommandHistoryDisplay.propTypes = {
  tab: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.number,
  pages: PropTypes.number,
  handlePageChange: PropTypes.func,
  error: PropTypes.string,
  dataLoading: PropTypes.bool,
  remote: PropTypes.bool,
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['Date']),
    order: PropTypes.oneOf(['asc', 'desc']),
  }),
  handleSortClick: PropTypes.func,
  toggleMobileFilters: PropTypes.func,
  showMobileFilters: PropTypes.bool,
  jobName: PropTypes.string,
  handleSearch: PropTypes.func,
};

AssetCommandHistoryDisplay.defaultProps = { data: [], sort: {} };
